var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{ 'TileData__highlighted': _vm.highlight }},[_c('td',[_vm._t("first-column")],2),_c('td',{staticClass:"text-center"},[_vm._t("second-column")],2),_c('td',{staticClass:"text-center"},[_vm._t("third-column")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }